import { Field } from "formik";
import { useCaseViewStyle } from "../../../components/CaseView/useCaseViewStyle";
import FMUTextField from "../../../components/shared/FormIkMUFormComponent/FMUTextField";
import NotesOutlinedIcon from "@mui/icons-material/NotesOutlined";

function ReferralNotesSection() {
  const classes = useCaseViewStyle();

  return (
    <div className={classes.rightContainer}>
      <div className={classes.rightInformationDiv}>
        <div className={classes.cardHead}>
          <span className={classes.cardHeadIcon}>
            <NotesOutlinedIcon />
          </span>
          <h5 className={classes.tabHeading}>Referral Notes</h5>
        </div>
        <div className={classes.cardBodyPad}>
          <Field
            name="case_detail.case_details.case_information.referral_notes"
            type="text"
            fullwidth={true}
            multiline={true}
            minRows={5}
            margin="none"
            InputProps={{ disableUnderline: true }}
            placeholder="Add referral notes…"
            className={classes.textField}
            component={FMUTextField}
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </div>
  );
}

export default ReferralNotesSection;
